// Tenant endpoints — nested under account. Create is the only B.1
// endpoint with the dual-write contract: a 201 carrying `X-Vault-Sync:
// error` is a SUCCESS path with degraded metadata, surfaced via
// ApiResponse.vaultSyncFailed.

import { request, type ApiResponse } from "../client";
import type { TenantCreate, TenantOut } from "../types/tenant";

export const tenants = {
  list: (accountSlug: string): Promise<ApiResponse<TenantOut[]>> =>
    request<TenantOut[]>(
      "GET",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants`,
    ),

  get: (
    accountSlug: string,
    tenantSlug: string,
  ): Promise<ApiResponse<TenantOut>> =>
    request<TenantOut>(
      "GET",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants/${encodeURIComponent(tenantSlug)}`,
    ),

  create: (
    accountSlug: string,
    body: TenantCreate,
  ): Promise<ApiResponse<TenantOut>> =>
    request<TenantOut>(
      "POST",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants`,
      body,
    ),

  // Retry the B.1 dual-write using the payload preserved on the row.
  // Same success-with-degraded-metadata contract as create: a 200 with
  // `X-Vault-Sync: error` means the retry attempt landed but Vault
  // still rejected; `vaultSyncFailed` on the response surfaces that.
  // 409 (vault_sync_not_needed / vault_sync_no_payload) throws ApiError.
  vaultResync: (
    accountSlug: string,
    tenantSlug: string,
  ): Promise<ApiResponse<TenantOut>> =>
    request<TenantOut>(
      "POST",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants/${encodeURIComponent(tenantSlug)}/vault-resync`,
    ),
};
